//src/services/statsService.js
import axiosInstance from "./axiosInstance";

// Lấy số liệu thống kê tổng quan
export const getStats = async () => {
    const res = await axiosInstance.get(`/stats`);
    return res.data;
};

// Lấy thống kê theo thời gian (theo năm)
export const getStatsByTime = async (year) => {
    const res = await axiosInstance.get(`/stats-by-time`, {
        params: { year },
    });
    return res.data;
};